import { ShapeTool } from ".";

const fabric = require("../fabric").fabric;

export class CircleTool extends ShapeTool {

  mesurementTexts = {
    area: null,
  };

  measurementActive = false;

  buildShape(pointer, origX, origY) {
    let styleModule = this.imageEditor.getModule("style");
    
    this.measurementActive = false;
    if(this.imageEditor.isToolbarToggleActive("mesures-toggle")) {
      this.measurementActive = true;
      
      this.mesurementTexts.area = this.getNewMesurementText(origX, origY);
      this.mesurementTexts.area.text = ``;

      this.imageEditor.canvas.add(this.mesurementTexts.area);
    }

    return new fabric.Circle({
      left: origX,
      top: origY,
      originX: 'left',
      originY: 'top',
      radius: pointer.x - origX,
      angle: 0,
      fill: "rgba(0,0,0,0)",
      stroke: styleModule.fillColor,
      strokeWidth: styleModule.strokeSize,
      transparentCorners: false,
      selectable: false
    });
  }

  mouseDrag(circle, pointer, origX, origY) {
    let radius = new fabric.Point(pointer.x, pointer.y).distanceFrom(new fabric.Point(origX, origY));

    circle.set({ radius: radius });
    circle.set({ left: origX - radius });
    circle.set({ top: origY - radius });

    if(this.measurementActive) {
      this.drawAreaMesurement(origX, origY, radius, circle.strokeWidth * 5);
    }
  }

  drawAreaMesurement(centerX, centerY, radius, fontSize) {
    var textObj = this.mesurementTexts.area;
    
    var r = this.imageEditor.calculateMesurementValue(radius);
    r = Math.round(r * 100) / 100;

    var area = Math.round(Math.PI * Math.pow(r, 2) * 100) / 100;

    textObj.text = `${area}${this.imageEditor.mesurementUnit}²`;
    textObj.fontSize = fontSize;
    textObj.left = centerX - textObj.width / 2;
    textObj.top = centerY - textObj.height / 2;
    textObj.drawObject(this.imageEditor.canvas.getContext());
  }

}